import { computed } from 'vue'
import { useStore } from 'vuex'
import getLabel from 'foundation/js/getLabel'

export default {
    name: 'SuccessPage',
    setup() {
        const store = useStore()

        const pageOverlayContentData = computed(() => {
            const data = store.state.main.page_overlay_content_data
            if (data === null) {
                throw Error('Overlay content data was not set')
            }
            return data
        })

        const succesButtonData = pageOverlayContentData.value.successButtonData

        return {
            getLabel,
            succesButtonData
        }
    }
}
